import { Box, forwardRef } from '@chakra-ui/react';
import type { ChipIconProps } from './chip-types';
import { getChipIconStyles } from './chip.theme';

export const ChipIcon = forwardRef<ChipIconProps, 'div'>(
  ({ icon, ...rest }, ref) => (
    <Box ref={ref} sx={getChipIconStyles()} {...rest}>
      {icon}
    </Box>
  )
);
